'use strict';

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var isFn = function isFn(test) {
  return typeof test === 'function';
};
var id = function id(Component) {
  return Component;
};

var Crate = exports.Crate = function () {
  function Crate(fn) {
    _classCallCheck(this, Crate);

    this.fn = fn || id;
    return this;
  }

  Crate.prototype.map = function map(fn) {
    return new this.constructor(fn(this.fn));
  };

  Crate.prototype.fold = function fold(fn) {
    return fn(this.fn);
  };

  Crate.prototype.compile = function compile() {
    var Component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'div';

    return this.fold(function (hoc) {
      return hoc(Component);
    });
  };

  Crate.prototype.hoc = function hoc(fn) {
    return this.map(function (hoc) {
      return function (Wrapped) {
        return hoc(fn(Wrapped));
      };
    });
  };

  Crate.of = function of(fnMap) {
    var CustomCrate = function (_prototype$constructo) {
      _inherits(CustomCrate, _prototype$constructo);

      function CustomCrate(fn) {
        var _ret;

        _classCallCheck(this, CustomCrate);

        var _this = _possibleConstructorReturn(this, _prototype$constructo.call(this, fn));

        return _ret = _this, _possibleConstructorReturn(_this, _ret);
      }

      return CustomCrate;
    }(this.prototype.constructor);

    Object.keys(fnMap).forEach(function (key) {
      var fn = fnMap[key];
      if ((typeof fn === 'undefined' ? 'undefined' : _typeof(fn)) === 'object') {
        Object.assign(CustomCrate.prototype, fn);
      } else {
        CustomCrate.prototype[key] = fn;
      }
    });

    return new CustomCrate();
  };

  return Crate;
}();


//////////////////
// WEBPACK FOOTER
// ./~/react-crate/lib/index.js
// module id = sFZx
// module chunks = 1